import * as types from '../mutation-types'
import dashboard from '../../api/dashboard';


// initial state
const state = {
    loaded: false,
    filterNumber: null,
    location: {
        name: ''
    }
}

// getters
const getters = {
    loaded: state => state.loaded,
    location: state => state.location,
    filterNumber: state => state.filterNumber
}

// actions
const actions = {
    async loadLocation({commit}, locationId) {
        let resp = await dashboard.loadLocation(locationId)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async ready({commit}, orderId) {
        await dashboard.ready(orderId);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async pickUp({commit}, orderId) {
        await dashboard.pickUp(orderId);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async remind({commit}, orderId) {
        await dashboard.remind(orderId);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async cancel({commit}, orderId) {
        await dashboard.cancel(orderId);
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async updateTableService({commit}, status) {
        await dashboard.updateTableService(state.location.id, status)
        let resp =await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    async updatePickUp({commit}, status) {
        await dashboard.updatePickUp(state.location.id, status)
        let resp = await dashboard.loadLocation(state.location.id)
        commit(types.DASHBOARD_LOAD_LOCATION, resp.data)
    },
    updateFilterNumber({commit}, number) {
        commit(types.DASHBOARD_FILTER_ORDERS, number)
    },
}

// mutations
const mutations = {
    [types.DASHBOARD_FILTER_ORDERS](state, number) {
        state.filterNumber = number
    },
    [types.DASHBOARD_LOAD_LOCATION](state, data) {
        state.loaded = true
        state.location = data
    },
    [types.DASHBOARD_UPDATE_ORDER](state, data) {
        state.loaded = true
        state.location = data
    },
    [types.DASHBOARD_TOGGLE_PAUSED](state) {
        state.paused = !state.paused
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
